// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11q3a","largestCol":"styles_largestCol__QRSLH","smallestCol":"styles_smallestCol__pta4I"};